const productData = {
  1: {
    monthly: "18.99",
    compare: "33.97",
    variantId: "44099353116930",
    sellingPlan: "3010134274"
  },
  2: {
    monthly: "33.98",
    compare: "79.95",
    variantId: "47266908766466",
    sellingPlan: "3511582978"
  },
  3: {
    monthly: "44.97",
    compare: "136.91",
    variantId: "47270377455874",
    sellingPlan: "3516072194"
  }
}

document.querySelectorAll('.save-lp__options-block').forEach((block) => {
  block.addEventListener('click', (e) => {
    const active = document.querySelector('.save-lp__options-block[is-active]');
    if (active) active.removeAttribute('is-active');
    block.setAttribute('is-active', '');

    const selectedBooks = Number(block.dataset.books);
    document.querySelectorAll('.save-lp__fg-product[data-books]').forEach((unlock) => {
      const unlockBooks = Number(unlock.dataset.books);
      if (selectedBooks >= unlockBooks) {
        unlock.classList.add('is-unlocked');
      } else {
        unlock.classList.remove('is-unlocked');
      }
    });

    document.querySelector(".monthly-price").innerHTML = `$${productData[selectedBooks].monthly}/month`;
    document.querySelector(".monthly-price__compare").innerHTML = `$${productData[selectedBooks].compare}`;
  });
});

const months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
document.querySelectorAll('.order-by-date').forEach((el) => {
  const date = new Date();
  if (isNaN(date)) return;
  const month = months[date.getMonth()];
  const day = date.getDate();
  const suffix =
    day % 10 === 1 && day !== 11
      ? 'st'
      : day % 10 === 2 && day !== 12
      ? 'nd'
      : day % 10 === 3 && day !== 13
      ? 'rd'
      : 'th';
  el.innerHTML = `${month} ${day}${suffix}`;
});

const atcButton = document.querySelector('.save-lp__atc');
atcButton.addEventListener('click', async function () {
  atcButton.classList.add('is-loading');

  const activeOption = document.querySelector(".save-lp__options-block[is-active='']");
  
  if (!activeOption) return;
  
  const variantId = activeOption.dataset.variantId;
  if (!variantId) return;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: {
        items: [
          {
            quantity: 1, 
            id: productData[activeOption.dataset.books].variantId,
            selling_plan: productData[activeOption.dataset.books].sellingPlan,
            form_type: "product",
            properties: {
              _custom_order_tag: `Multi-book: ${activeOption.dataset.books}`
            }
          }
        ]
      }
    });

    const data = await response.json();

    if (!response.ok) throw new Error('ATC failed');
    window.location.href = '/checkout';
  } catch (err) {
    console.error(err);
    atcButton.classList.remove('is-loading');
  }
});
